




















































import {Component, Emit, Vue} from 'vue-property-decorator';
import {CommonActionTypes} from '@/store/actions/types';
import {CertificateListPretty} from '@/maps/pretty/common';
import {
  CERTIFICATE_LEVEL_MAP,
  CERTIFICATE_TEMPLATE,
  CERTIFICATE_TEMPLATE_MAP
} from '@/views/media/certificate/components/filter';
import {mapActions} from 'vuex';

@Component({
  methods: {
    ...mapActions({getPrintList: CommonActionTypes.GET_CERTIFICATE_LIST})
  }
})
export default class CampFilterComponent extends Vue {

  [x: string]: any;

  /**模板列表*/
  private certificateTemplate = CERTIFICATE_TEMPLATE_MAP;

  private levelMap = CERTIFICATE_LEVEL_MAP;

  /**列表加载loading*/
  private listLoading: boolean = false;

  /**打印列表*/
  private printList: Array<any> = [];
  /**证书等级*/
  private level: number | undefined = 0;

  /**显示*/
  private showItem: { certificate: boolean } = {certificate: false};


  /**打印列表点击*/
  @Emit('itemClick')
  public printItemClick(ary: Array<CertificateListPretty>, name: string) {
    this.level = 0;
    return Promise.resolve({data: ary, file: name});
  }

  @Emit('printStart')
  public printStart() {
    if (!this.level && this.level == 0) {
      this.$message.error('选择证书等级');
      return Promise.reject();
    }
    return Promise.resolve();
  }

  /**等级选择*/
  @Emit('levelChange')
  public async levelChange(level: number) {
    this.level = level;
    return Promise.resolve(level);
  }

  /**模板选择*/
  @Emit('templateChange')
  public async templateChange(event: CERTIFICATE_TEMPLATE) {
    this.listLoading = true;
    this.initShow();
    switch (event) {
      case CERTIFICATE_TEMPLATE.CAMP:
      case CERTIFICATE_TEMPLATE.CAMP_2:
        this.$set(this.showItem, 'certificate', true);
        //五天短期集训证书
        this.getPrintList({
          params: {
            semester_id: 20,
            start_date: '2022-01-11'
          }
        })
          .then((list: Array<CertificateListPretty>) => {
            this.$set(this, 'printList', list);
            return Promise.resolve(event);
          })
          .catch((err: any) => {
            this.$set(this, 'printList', []);
            this.$message.error(err);
          })
          .finally(() => {
            this.listLoading = false;
          });
        break;
    }
  }

  /**初始化显示*/
  public initShow() {
    this.$set(this, 'showItem', {certificate: false});
  }


}
